<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			:error="inputErrors.title"
			label="כותרת"
			v-model="form.title"
			name="title"
		></smart-input>
		<smart-input
			:error="inputErrors.content"
			label="תוכן"
			v-model="form.content"
			name="content"
		></smart-input>
		<v-checkbox label="הצג תמונה" name="with_image" value="1" v-model="form.withImage"/>
		<v-row v-if="form.withImage">
			<v-col cols="12" md="5">
				<smart-input
					:error="inputErrors.img"
					label="תמונה"
					name="img"
					type="file"
				/>
			</v-col>
			<v-col cols="12" md="5">
				<v-img v-if="form.image.length" :src="form.image[0]"/>
			</v-col>
		</v-row>
		<v-switch label="הצג מודעה"  name="show" value="1"  v-model="form.show"></v-switch>
		<v-switch label="מודעה רצה"  name="is_run" value="1"  v-model="form.is_run"></v-switch>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>

<script>
	import NotificationModule from "src/store/modules/Notification.module";
	import FormView from "src/mixins/FormView";
	import SmartInput from "../../scaffoldings/SmartInput.vue";

	export default {
		name: "notification-form",
		components: {SmartInput},
		data() {
			return {
				form: {show: true, withImage: true,is_run:true},
			};
		},
		mixins: [new FormView(NotificationModule, "notification", true)],
		computed: {
			isNew() {
				return !!this.notification.id;
			},
			hasImage(){
				return !!this.form.image && this.form.image.length;
			}
		},
		watch: {
			form() {
				this.$set(this.form,"withImage",this.hasImage ? "1":null);
				this.$set(this.form,"show",this.form.show ? "1":null);
				this.$set(this.form,"is_run",this.form.is_run ? "1":null);
			}
		},
		methods: {
			delImg(val) {
				this.form.withImage = val;

			}
		},
	};
</script>

<style></style>
